import { useEffect } from 'react';
import { VerificationStatus } from 'src/common/models/verificationModels';

const isVerificationInProgress = (status?: VerificationStatus) => {
  return !(
    status === VerificationStatus.Done ||
    status === VerificationStatus.Expired ||
    status === VerificationStatus.Failed
  );
};

export const useBeforeUnload = (status?: VerificationStatus) => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };

    if (isVerificationInProgress(status)) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [status]);
};
